import {ILanguage, LANG_OPTIONS} from "@/components/Providers/LanguageProvider";
import {find, propEq} from "ramda";

export function findLangBasedOnLocale(locale: string): ILanguage {
	const result = find<ILanguage>(propEq('locale', locale))(LANG_OPTIONS);

	return result ? result : LANG_OPTIONS[0];
}
